import { createStyles, Flex } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import Color from 'color';

import dt from '~/domains/contest/domains/game/domains/common/testing.const';

const useStyles = createStyles((theme) => ({
  infoWrapper: {
    padding: theme.other.spacing._8,
    minWidth: 104,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: Color(theme.colors.gray2[1]).alpha(0.7).toString(),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottomLeftRadius: theme.other.spacing._8 - 2,
    borderBottomRightRadius: theme.other.spacing._8 - 2,
  },
}));

type PlayerCardInfoProps = {
  children: React.ReactNode;
  isLocked?: boolean;
  isTier?: boolean;
  withoutTier?: boolean;
};

export function PlayerCardInfo({
  children,
  isTier,
  withoutTier,
  isLocked = false,
}: PlayerCardInfoProps) {
  const { classes } = useStyles();

  if (withoutTier && isLocked) {
    return (
      <div className={classes.infoWrapper} data-test-id={dt.dfs.playerCard.info}>
        <div className={classes.overlay}>
          <IconLock size={40} />
        </div>
        {children}
      </div>
    );
  }

  return (
    <div className={classes.infoWrapper} data-test-id={dt.dfs.playerCard.info}>
      {isLocked && isTier ? (
        <div className={classes.overlay}>
          <IconLock size={40} />
        </div>
      ) : null}
      {children}
    </div>
  );
}
